module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h4', {
    staticClass: "subc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Irgun Anthem")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Tagar –")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Through all obstacles and enemies")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Whether you go up or down")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In the flames of revolt")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Carry a flame to kindle—never mind!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For silence is filth")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Worthless is blood and soul")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For the sake of the hidden glory")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To die or to conquer the hill –")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Yodefet, Masada, Betar")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07bdcb04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Irgunanthem.vue
// module id = 69
// module chunks = 0